import React, { useState } from 'react';

function VillageVideoSection({ videos }) {
  const [playingId, setPlayingId] = useState(null);

  if (!videos || videos.length === 0) {
    return null;
  }

  return (
    <div className="video-section">
      <h2 className="section-title"> वीडियो और डॉक्यूमेंटरी</h2>

      {/* Main Video Player */}
      {playingId && (
        <div style={{
          marginBottom: '30px',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}>
          <div style={{position: 'relative', paddingBottom: '56.25%', height: 0}}>
            <iframe
              style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none'}}
              src={`https://www.youtube.com/embed/${playingId}?autoplay=1`}
              title="Playing Video"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}

      {/* Video Grid */}
      <div className="videos-grid">
        {videos.map(video => (
          <div
            key={video.id}
            className="video-card"
            onClick={() => setPlayingId(video.youtubeId)}
            style={{cursor: 'pointer'}}
          >
            <div className="video-thumbnail">
              <img src={video.thumbnail} alt={video.title} />
              <div className="video-play-button">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
            <div className="video-card-title">{video.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VillageVideoSection;
